import KardiaRxCCTWorkListResult from './KardiaRxCCTWorkListResult';

export default KardiaRxCCTWorkListResult;



// WEBPACK FOOTER //
// ./src/views/containers/KardiaRxCCTWorkListResult/index.js